<template>
	<div>
		<banner-simulator
			:country-code="userData.countryCode"
			:latitude="userData.lat"
			:longitude="userData.lon"
		></banner-simulator>
		<section-slider/>
		<company-data />
		<app-footer />
	</div>
</template>

<script>
	import bannerSimulator from '@/components/simulator/banner-simulator';
	import sectionSlider from '@/components/simulator/section-slider';
	import companyData from '@/components/home-new/company-data';
	import appFooter from '@/components/home-new/app-footer';

	function created() {
		this.loadData();
	}

	async function loadData() {
		const query = this.$route.query;
		if (query.code && query.lat && query.lon) {
			this.userData = {
				countryCode: query.code,
				lat: query.lat,
				lon: query.lon,
			};
		}	else {
			({ data: this.userData } = await this.$httpApi.get('ip-api'));
			const ipData = JSON.stringify(this.userData);
			localStorage.setItem('casamarket::ip-data', ipData);
		}
	}

	function data() {
		return {
			userData: {},
		};
	}

	export default {
		name: 'page-simulator',
		components: {
			bannerSimulator,
			sectionSlider,
			companyData,
			appFooter,
		},
		created,
		data,
		methods: {
			loadData,
		},
	};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/page-simulator.vue